import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LicenseSettingsComponent} from './license-settings.component';
import {ArmFormModule} from '../../../components/arm-form/arm-form.module';
import {ArmFormTitleModule} from '../../../components/arm-form/arm-form-title/arm-form-title.module';
import {FormsModule} from '@angular/forms';
import {MaterialModule} from '../../../material.module';
import {ClipboardModule} from '@angular/cdk/clipboard';

@NgModule({
    declarations: [
        LicenseSettingsComponent
    ],
    imports: [
        CommonModule,
        ArmFormModule,
        ArmFormTitleModule,
        FormsModule,
        MaterialModule,
        ClipboardModule
    ]
})
export class LicenseSettingsModule {
}
